import { render } from "./LearningAssistantPanel.vue?vue&type=template&id=0184b624&scoped=true"
import script from "./LearningAssistantPanel.vue?vue&type=script&lang=js"
export * from "./LearningAssistantPanel.vue?vue&type=script&lang=js"

import "./LearningAssistantPanel.vue?vue&type=style&index=0&id=0184b624&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0184b624"]])

export default __exports__